import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useList, useObject } from 'react-firebase-hooks/database';
import { Redirect, useHistory } from "react-router";
import "./Dashboard.css";
import { auth, db, firebase_update_user_info, firebase_update_client_info} from "./firebase";

import Level from "./guages/level";
import Pressure from "./guages/pressure";
import Temp from "./guages/temp";
import Heat from "./guages/heat";
import GasLeak from "./guages/gasleak";
import Vaporizer from "./guages/vaporizer";

import Map from "./components/map";


import { useLocation } from 'react-router-dom';


import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';

import ListItemIcon from '@mui/material/ListItemIcon';
import EditIcon from '@mui/icons-material/Edit';


import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';


import FaceIcon from '@mui/icons-material/Face';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import PsychologyIcon from '@mui/icons-material/Psychology';
import BuildCircleIcon from '@mui/icons-material/BuildCircle';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import Avatar from '@mui/material/Avatar';

import Snackbar from '@mui/material/Snackbar';

import Styles from './Styles';


function UserInfo(props){
  const photoURL = sessionStorage.getItem('photoURL');
  const displayName = sessionStorage.getItem('displayName');
  const email = sessionStorage.getItem('email');
  const history = useHistory();

  const r = '/system_management/users/' + props.uid;

  const [user_snapshot, loading_user_snapshot, error_db] = useObject(db.ref(r));

  const [userInfo, setUserInfo] = useState();
  const [userRole, setUserRole] = useState();
  const [isAdmin, setIsAdmin] = useState(false);

  const [openChangeUserRoleSnackbar, setOpenChangeUserRoleSnackbar] = useState(false);
  const [changeUserMessage, setChangeUserMessage] = useState();


  useEffect(() => {
      setIsAdmin((sessionStorage.getItem('admin')=='true') || (sessionStorage.getItem('power_user')=='ture'));
      if(user_snapshot && !loading_user_snapshot)
      {
        setUserInfo(user_snapshot.val());
        setUserRole(user_snapshot.val().role);
      }
  }, [user_snapshot, loading_user_snapshot]);


  if (loading_user_snapshot)
  {
    return (<div style={{alignItems: "center", display: 'flex', justifyContent: 'center', height: "100vh", width: "100vw" }}>
            <Box sx={{ display: 'flex' }}>
              <Typography variant="caption" style={{textAlign: "center"}} component="div" color="text.secondary">
                <CircularProgress /><br />
                Loading user data...
              </Typography>
            </Box>
            </div>);
  }

  const handleUpdateUserRole = (role) => {
   if(isAdmin)
   {
     switch(role)
     {
        case "user": if(userRole.user == "true")
                      {
                        firebase_update_user_info(props.uid + '/role',
                        {
                          "user": "false"
                        });
                        setChangeUserMessage("Disable user role");
                      }
                      else
                      {
                        firebase_update_user_info(props.uid + '/role',
                        {
                          "user": "true"
                        });
                        setChangeUserMessage("Enable user role");
                      }
                      break;
        case "admin": if(userRole.admin == "true")
                        {
                          firebase_update_user_info(props.uid + '/role',
                          {
                            "admin": "false"
                          });
                          setChangeUserMessage("Disable admin role");
                        }
                        else
                        {
                          firebase_update_user_info(props.uid + '/role',
                          {
                            "admin": "true"
                          });
                          setChangeUserMessage("Enable admin role");
                        }
                      break;
        case "manager": if(userRole.manager == "true")
                        {
                          firebase_update_user_info(props.uid + '/role',
                          {
                            "manager": "false"
                          });
                          setChangeUserMessage("Disable manager role");
                        }
                        else
                        {
                          firebase_update_user_info(props.uid + '/role',
                          {
                            "manager": "true"
                          });
                          setChangeUserMessage("Enable manager role");
                        }
                      break;
        case "power_user": if(userRole.power_user == "true")
                        {
                          firebase_update_user_info(props.uid + '/role',
                          {
                            "power_user": "false"
                          });
                          setChangeUserMessage("Disable power user role");
                        }
                        else
                        {
                          firebase_update_user_info(props.uid + '/role',
                          {
                            "power_user": "true"
                          });
                          setChangeUserMessage("Enable power user role");
                        }
                      break;
        case "sale": if(userRole.sale == "true")
                        {
                          firebase_update_user_info(props.uid + '/role',
                          {
                            "sale": "false"
                          });
                          setChangeUserMessage("Disable sale role");
                        }
                        else
                        {
                          firebase_update_user_info(props.uid + '/role',
                          {
                            "sale": "true"
                          });
                          setChangeUserMessage("Enable sale role");
                        }
                      break;
        case "technician": if(userRole.technician == "true")
                      {
                        firebase_update_user_info(props.uid + '/role',
                        {
                          "technician": "false"
                        });
                        setChangeUserMessage("Disable technician role");
                      }
                      else
                      {
                        firebase_update_user_info(props.uid + '/role',
                        {
                          "technician": "true"
                        });
                        setChangeUserMessage("Enable technician role");
                      }
                      break;
     }
     setOpenChangeUserRoleSnackbar(true);
   }
  }


  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenChangeUserRoleSnackbar(false);
  };

  return (<div className="container" style={{height: '100%'}}>  
          { userInfo ? (
            <Card style={{ height: '100%'}}>
            <CardHeader
              avatar={
                <Avatar 
                  src={userInfo.photoURL}
                  aria-label="user-profile" />
              }
              action={
                <IconButton aria-label="settings">
                  <MoreVertIcon />
                </IconButton>
              }
              title={userInfo.displayName}
              subheader={userInfo.email}
            />
            <CardContent>
                  {
                    userRole ? (
                      
                      <Grid container>
                        <Tooltip title="Click to toggle role" arrow placement="left">
                          <Grid item xs={12}>
                            <Stack direction="row" flexWrap={"wrap"}>      
                            {userRole.user == "true" ? <Chip sx={{margin: "2px"}} icon={<FaceIcon />} label="user" color="success" onClick={(e) => handleUpdateUserRole("user")} /> : (isAdmin && <Chip sx={{margin: "2px"}} icon={<FaceIcon />} label="user" onClick={(e) => handleUpdateUserRole("user")}/>)}
                            {userRole.admin == "true" ? <Chip sx={{margin: "2px"}} icon={<AdminPanelSettingsIcon />} label="admin" color="success" onClick={(e) => handleUpdateUserRole("admin")}/> : (isAdmin && <Chip sx={{margin: "2px"}} icon={<AdminPanelSettingsIcon />} label="admin" onClick={(e) => handleUpdateUserRole("admin")} />)}
                            {userRole.manager == "true" ? <Chip sx={{margin: "2px"}} icon={<ManageAccountsIcon />} label="manager" color="success" onClick={(e) => handleUpdateUserRole("manager")}/> : (isAdmin && <Chip sx={{margin: "2px"}} icon={<ManageAccountsIcon />} label="manager" onClick={(e) => handleUpdateUserRole("manager")}/>)}
                            {userRole.power_user == "true" ? <Chip sx={{margin: "2px"}} icon={<PsychologyIcon />} label="power user" color="success" onClick={(e) => handleUpdateUserRole("power_user")}/> : (isAdmin && <Chip sx={{margin: "2px"}} icon={<PsychologyIcon />} label="power user" onClick={(e) => handleUpdateUserRole("power_user")}/>)}
                            {userRole.sale == "true" ? <Chip sx={{margin: "2px"}} icon={<MonetizationOnIcon />} label="sale" color="success" onClick={(e) => handleUpdateUserRole("sale")}/> : (isAdmin && <Chip sx={{margin: "2px"}} icon={<MonetizationOnIcon />} label="sale" onClick={(e) => handleUpdateUserRole("sale")}/>)}
                            {userRole.technician == "true" ? <Chip sx={{margin: "2px"}} icon={<BuildCircleIcon />} label="technician" color="success" onClick={(e) => handleUpdateUserRole("technician")}/> : (isAdmin && <Chip sx={{margin: "2px"}} icon={<BuildCircleIcon />} label="technician" onClick={(e) => handleUpdateUserRole("technician")}/>)}
                            </Stack>
                            <Snackbar
                              open={openChangeUserRoleSnackbar}
                              autoHideDuration={6000}
                              onClose={handleCloseSnackbar}
                              message={changeUserMessage}
                            />
                          </Grid>
                      </Tooltip>
                      </Grid>
                    ): (<></>)
                  }      
                <Typography sx={{pt: 4}} variant="body2">
                User info display here.
                </Typography>
            </CardContent>
                    
          </Card>) : (<></>)}
          </div>);
}

export default UserInfo;
